// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
export * from './cardExtV1Api';
import { CardExtV1Api } from './cardExtV1Api';
export * from './caseV3Api';
import { CaseV3Api } from './caseV3Api';
export * from './claimV1Api';
import { ClaimV1Api } from './claimV1Api';
export * from './diagnosisV3Api';
import { DiagnosisV3Api } from './diagnosisV3Api';
export * from './documentV3Api';
import { DocumentV3Api } from './documentV3Api';
export * from './edgeApi';
import { EdgeApi } from './edgeApi';
export * from './edgeAccountApi';
import { EdgeAccountApi } from './edgeAccountApi';
export * from './edgeAdminApi';
import { EdgeAdminApi } from './edgeAdminApi';
export * from './edgeAuthenticationApi';
import { EdgeAuthenticationApi } from './edgeAuthenticationApi';
export * from './edgeCardApi';
import { EdgeCardApi } from './edgeCardApi';
export * from './edgeClaimApi';
import { EdgeClaimApi } from './edgeClaimApi';
export * from './edgeCmmApi';
import { EdgeCmmApi } from './edgeCmmApi';
export * from './edgeCouponApi';
import { EdgeCouponApi } from './edgeCouponApi';
export * from './edgeDebitCardApi';
import { EdgeDebitCardApi } from './edgeDebitCardApi';
export * from './edgeDigitalPaymentApi';
import { EdgeDigitalPaymentApi } from './edgeDigitalPaymentApi';
export * from './edgeDocumentsApi';
import { EdgeDocumentsApi } from './edgeDocumentsApi';
export * from './edgeEmailApi';
import { EdgeEmailApi } from './edgeEmailApi';
export * from './edgeEmdApi';
import { EdgeEmdApi } from './edgeEmdApi';
export * from './edgeEnrollmentApi';
import { EdgeEnrollmentApi } from './edgeEnrollmentApi';
export * from './edgeHhsApi';
import { EdgeHhsApi } from './edgeHhsApi';
export * from './edgeHubApi';
import { EdgeHubApi } from './edgeHubApi';
export * from './edgeIntakeApi';
import { EdgeIntakeApi } from './edgeIntakeApi';
export * from './edgeMangoApi';
import { EdgeMangoApi } from './edgeMangoApi';
export * from './edgeMedicalApi';
import { EdgeMedicalApi } from './edgeMedicalApi';
export * from './edgePatientAccountApi';
import { EdgePatientAccountApi } from './edgePatientAccountApi';
export * from './edgePatientEnrollmentApi';
import { EdgePatientEnrollmentApi } from './edgePatientEnrollmentApi';
export * from './edgePayloadStagingApi';
import { EdgePayloadStagingApi } from './edgePayloadStagingApi';
export * from './edgePayorApi';
import { EdgePayorApi } from './edgePayorApi';
export * from './edgePharmacyApi';
import { EdgePharmacyApi } from './edgePharmacyApi';
export * from './edgePlpApi';
import { EdgePlpApi } from './edgePlpApi';
export * from './edgePorticoApi';
import { EdgePorticoApi } from './edgePorticoApi';
export * from './edgeProgramApi';
import { EdgeProgramApi } from './edgeProgramApi';
export * from './edgeSignatureApi';
import { EdgeSignatureApi } from './edgeSignatureApi';
export * from './edgeSiteAccountApi';
import { EdgeSiteAccountApi } from './edgeSiteAccountApi';
export * from './edgeTempApi';
import { EdgeTempApi } from './edgeTempApi';
export * from './edgeTenantApi';
import { EdgeTenantApi } from './edgeTenantApi';
export * from './edgeTokenApi';
import { EdgeTokenApi } from './edgeTokenApi';
export * from './emailV1Api';
import { EmailV1Api } from './emailV1Api';
export * from './enrollmentExtV2Api';
import { EnrollmentExtV2Api } from './enrollmentExtV2Api';
export * from './enrollmentV1Api';
import { EnrollmentV1Api } from './enrollmentV1Api';
export * from './escoordV1Api';
import { EscoordV1Api } from './escoordV1Api';
export * from './intakeV1Api';
import { IntakeV1Api } from './intakeV1Api';
export * from './locationV1Api';
import { LocationV1Api } from './locationV1Api';
export * from './notesV2Api';
import { NotesV2Api } from './notesV2Api';
export * from './patientV3Api';
import { PatientV3Api } from './patientV3Api';
export * from './payorV4Api';
import { PayorV4Api } from './payorV4Api';
export * from './payorV4GlobalApi';
import { PayorV4GlobalApi } from './payorV4GlobalApi';
export * from './pharmacyV2Api';
import { PharmacyV2Api } from './pharmacyV2Api';
export * from './pharmacyV2GlobalApi';
import { PharmacyV2GlobalApi } from './pharmacyV2GlobalApi';
export * from './prescriberV3Api';
import { PrescriberV3Api } from './prescriberV3Api';
export * from './prescriptionV1Api';
import { PrescriptionV1Api } from './prescriptionV1Api';
export * from './programV2Api';
import { ProgramV2Api } from './programV2Api';
export * from './siteV2Api';
import { SiteV2Api } from './siteV2Api';
export * from './siteV3Api';
import { SiteV3Api } from './siteV3Api';
export * from './surveyV2Api';
import { SurveyV2Api } from './surveyV2Api';
export * from './surveyV3Api';
import { SurveyV3Api } from './surveyV3Api';
import { Lazy, Scoped } from 'vue-di';
export * from './configure';
let ApigatewayApi = class ApigatewayApi {
    constructor(_cardExtV1, _caseV3, _claimV1, _diagnosisV3, _documentV3, _edge, _edgeAccount, _edgeAdmin, _edgeAuthentication, _edgeCard, _edgeClaim, _edgeCmm, _edgeCoupon, _edgeDebitCard, _edgeDigitalPayment, _edgeDocuments, _edgeEmail, _edgeEmd, _edgeEnrollment, _edgeHhs, _edgeHub, _edgeIntake, _edgeMango, _edgeMedical, _edgePatientAccount, _edgePatientEnrollment, _edgePayloadStaging, _edgePayor, _edgePharmacy, _edgePlp, _edgePortico, _edgeProgram, _edgeSignature, _edgeSiteAccount, _edgeTemp, _edgeTenant, _edgeToken, _emailV1, _enrollmentExtV2, _enrollmentV1, _escoordV1, _intakeV1, _locationV1, _notesV2, _patientV3, _payorV4, _payorV4Global, _pharmacyV2, _pharmacyV2Global, _prescriberV3, _prescriptionV1, _programV2, _siteV2, _siteV3, _surveyV2, _surveyV3) {
        this._cardExtV1 = _cardExtV1;
        this._caseV3 = _caseV3;
        this._claimV1 = _claimV1;
        this._diagnosisV3 = _diagnosisV3;
        this._documentV3 = _documentV3;
        this._edge = _edge;
        this._edgeAccount = _edgeAccount;
        this._edgeAdmin = _edgeAdmin;
        this._edgeAuthentication = _edgeAuthentication;
        this._edgeCard = _edgeCard;
        this._edgeClaim = _edgeClaim;
        this._edgeCmm = _edgeCmm;
        this._edgeCoupon = _edgeCoupon;
        this._edgeDebitCard = _edgeDebitCard;
        this._edgeDigitalPayment = _edgeDigitalPayment;
        this._edgeDocuments = _edgeDocuments;
        this._edgeEmail = _edgeEmail;
        this._edgeEmd = _edgeEmd;
        this._edgeEnrollment = _edgeEnrollment;
        this._edgeHhs = _edgeHhs;
        this._edgeHub = _edgeHub;
        this._edgeIntake = _edgeIntake;
        this._edgeMango = _edgeMango;
        this._edgeMedical = _edgeMedical;
        this._edgePatientAccount = _edgePatientAccount;
        this._edgePatientEnrollment = _edgePatientEnrollment;
        this._edgePayloadStaging = _edgePayloadStaging;
        this._edgePayor = _edgePayor;
        this._edgePharmacy = _edgePharmacy;
        this._edgePlp = _edgePlp;
        this._edgePortico = _edgePortico;
        this._edgeProgram = _edgeProgram;
        this._edgeSignature = _edgeSignature;
        this._edgeSiteAccount = _edgeSiteAccount;
        this._edgeTemp = _edgeTemp;
        this._edgeTenant = _edgeTenant;
        this._edgeToken = _edgeToken;
        this._emailV1 = _emailV1;
        this._enrollmentExtV2 = _enrollmentExtV2;
        this._enrollmentV1 = _enrollmentV1;
        this._escoordV1 = _escoordV1;
        this._intakeV1 = _intakeV1;
        this._locationV1 = _locationV1;
        this._notesV2 = _notesV2;
        this._patientV3 = _patientV3;
        this._payorV4 = _payorV4;
        this._payorV4Global = _payorV4Global;
        this._pharmacyV2 = _pharmacyV2;
        this._pharmacyV2Global = _pharmacyV2Global;
        this._prescriberV3 = _prescriberV3;
        this._prescriptionV1 = _prescriptionV1;
        this._programV2 = _programV2;
        this._siteV2 = _siteV2;
        this._siteV3 = _siteV3;
        this._surveyV2 = _surveyV2;
        this._surveyV3 = _surveyV3;
    }
    get cardExtV1() { return this._cardExtV1(); }
    get caseV3() { return this._caseV3(); }
    get claimV1() { return this._claimV1(); }
    get diagnosisV3() { return this._diagnosisV3(); }
    get documentV3() { return this._documentV3(); }
    get edge() { return this._edge(); }
    get edgeAccount() { return this._edgeAccount(); }
    get edgeAdmin() { return this._edgeAdmin(); }
    get edgeAuthentication() { return this._edgeAuthentication(); }
    get edgeCard() { return this._edgeCard(); }
    get edgeClaim() { return this._edgeClaim(); }
    get edgeCmm() { return this._edgeCmm(); }
    get edgeCoupon() { return this._edgeCoupon(); }
    get edgeDebitCard() { return this._edgeDebitCard(); }
    get edgeDigitalPayment() { return this._edgeDigitalPayment(); }
    get edgeDocuments() { return this._edgeDocuments(); }
    get edgeEmail() { return this._edgeEmail(); }
    get edgeEmd() { return this._edgeEmd(); }
    get edgeEnrollment() { return this._edgeEnrollment(); }
    get edgeHhs() { return this._edgeHhs(); }
    get edgeHub() { return this._edgeHub(); }
    get edgeIntake() { return this._edgeIntake(); }
    get edgeMango() { return this._edgeMango(); }
    get edgeMedical() { return this._edgeMedical(); }
    get edgePatientAccount() { return this._edgePatientAccount(); }
    get edgePatientEnrollment() { return this._edgePatientEnrollment(); }
    get edgePayloadStaging() { return this._edgePayloadStaging(); }
    get edgePayor() { return this._edgePayor(); }
    get edgePharmacy() { return this._edgePharmacy(); }
    get edgePlp() { return this._edgePlp(); }
    get edgePortico() { return this._edgePortico(); }
    get edgeProgram() { return this._edgeProgram(); }
    get edgeSignature() { return this._edgeSignature(); }
    get edgeSiteAccount() { return this._edgeSiteAccount(); }
    get edgeTemp() { return this._edgeTemp(); }
    get edgeTenant() { return this._edgeTenant(); }
    get edgeToken() { return this._edgeToken(); }
    get emailV1() { return this._emailV1(); }
    get enrollmentExtV2() { return this._enrollmentExtV2(); }
    get enrollmentV1() { return this._enrollmentV1(); }
    get escoordV1() { return this._escoordV1(); }
    get intakeV1() { return this._intakeV1(); }
    get locationV1() { return this._locationV1(); }
    get notesV2() { return this._notesV2(); }
    get patientV3() { return this._patientV3(); }
    get payorV4() { return this._payorV4(); }
    get payorV4Global() { return this._payorV4Global(); }
    get pharmacyV2() { return this._pharmacyV2(); }
    get pharmacyV2Global() { return this._pharmacyV2Global(); }
    get prescriberV3() { return this._prescriberV3(); }
    get prescriptionV1() { return this._prescriptionV1(); }
    get programV2() { return this._programV2(); }
    get siteV2() { return this._siteV2(); }
    get siteV3() { return this._siteV3(); }
    get surveyV2() { return this._surveyV2(); }
    get surveyV3() { return this._surveyV3(); }
};
ApigatewayApi = __decorate([
    Scoped,
    __param(0, Lazy(CardExtV1Api)),
    __param(1, Lazy(CaseV3Api)),
    __param(2, Lazy(ClaimV1Api)),
    __param(3, Lazy(DiagnosisV3Api)),
    __param(4, Lazy(DocumentV3Api)),
    __param(5, Lazy(EdgeApi)),
    __param(6, Lazy(EdgeAccountApi)),
    __param(7, Lazy(EdgeAdminApi)),
    __param(8, Lazy(EdgeAuthenticationApi)),
    __param(9, Lazy(EdgeCardApi)),
    __param(10, Lazy(EdgeClaimApi)),
    __param(11, Lazy(EdgeCmmApi)),
    __param(12, Lazy(EdgeCouponApi)),
    __param(13, Lazy(EdgeDebitCardApi)),
    __param(14, Lazy(EdgeDigitalPaymentApi)),
    __param(15, Lazy(EdgeDocumentsApi)),
    __param(16, Lazy(EdgeEmailApi)),
    __param(17, Lazy(EdgeEmdApi)),
    __param(18, Lazy(EdgeEnrollmentApi)),
    __param(19, Lazy(EdgeHhsApi)),
    __param(20, Lazy(EdgeHubApi)),
    __param(21, Lazy(EdgeIntakeApi)),
    __param(22, Lazy(EdgeMangoApi)),
    __param(23, Lazy(EdgeMedicalApi)),
    __param(24, Lazy(EdgePatientAccountApi)),
    __param(25, Lazy(EdgePatientEnrollmentApi)),
    __param(26, Lazy(EdgePayloadStagingApi)),
    __param(27, Lazy(EdgePayorApi)),
    __param(28, Lazy(EdgePharmacyApi)),
    __param(29, Lazy(EdgePlpApi)),
    __param(30, Lazy(EdgePorticoApi)),
    __param(31, Lazy(EdgeProgramApi)),
    __param(32, Lazy(EdgeSignatureApi)),
    __param(33, Lazy(EdgeSiteAccountApi)),
    __param(34, Lazy(EdgeTempApi)),
    __param(35, Lazy(EdgeTenantApi)),
    __param(36, Lazy(EdgeTokenApi)),
    __param(37, Lazy(EmailV1Api)),
    __param(38, Lazy(EnrollmentExtV2Api)),
    __param(39, Lazy(EnrollmentV1Api)),
    __param(40, Lazy(EscoordV1Api)),
    __param(41, Lazy(IntakeV1Api)),
    __param(42, Lazy(LocationV1Api)),
    __param(43, Lazy(NotesV2Api)),
    __param(44, Lazy(PatientV3Api)),
    __param(45, Lazy(PayorV4Api)),
    __param(46, Lazy(PayorV4GlobalApi)),
    __param(47, Lazy(PharmacyV2Api)),
    __param(48, Lazy(PharmacyV2GlobalApi)),
    __param(49, Lazy(PrescriberV3Api)),
    __param(50, Lazy(PrescriptionV1Api)),
    __param(51, Lazy(ProgramV2Api)),
    __param(52, Lazy(SiteV2Api)),
    __param(53, Lazy(SiteV3Api)),
    __param(54, Lazy(SurveyV2Api)),
    __param(55, Lazy(SurveyV3Api)),
    __metadata("design:paramtypes", [Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function, Function])
], ApigatewayApi);
export { ApigatewayApi };
//# sourceMappingURL=apis.js.map